/**
 * Ticket types
 * @type {{SINGLE: {id: number, name: string}}}
 */

export const  TICKET_TYPES = {

    SINGLE:  {
        id:3,
        name:'single'
    }

};





// WEBPACK FOOTER //
// ticketTypes.js